import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getBinsForProducts = {
  name: "getBinsForProducts" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    productIds: z.array(productIdFormat.schema),
    includeStorage: z.boolean().nullish(),
    includeReceiving: z.boolean().nullish(),
    useTransferTypeFilter: z.boolean().nullish(),
    includeUncounted: z.boolean().nullish(),
    includeZeroAvailable: z.boolean().nullish(),
    excludeBinType: z.boolean().nullish(),
  }),
  output: z.object({
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        bins: z.array(
          z.object({
            storageLocationId: storageLocationIdFormat.schema,
            inventoryItemId: z.string().nullable().optional(),
            binName: z.string(),
            binType: z.string().nullable().optional(),
            availableQuantity: z.number(),
            lastCountedAt: z.date().nullable().optional(),
            lotNumber: z.string().nullable().optional(),
            expirationDate: z.date().nullable().optional(),
          }),
        ),
      }),
    ),
  }),
};
